import React from "react";
import { object } from "prop-types";
import { SeatMap } from "./SeatMap";

const SeatMapConnector = ({ data }) => (
	<SeatMap title={data.title} image={data.image} seatDescriptions={data.seatDescriptions} />
);

SeatMapConnector.propTypes = {
	data: object,
};
SeatMapConnector.defaultProps = {
	data: null,
};

export default SeatMapConnector;
export { SeatMapConnector };
